import IconAlibabaCloud from "@/ui-lib/icons/IconAlibabaCloud";
import IconAwsCloud from "@/ui-lib/icons/IconAws";
import IconAzure from "@/ui-lib/icons/IconAzure";
import IconGCP from "@/ui-lib/icons/IconGCP";
import IconMongoDb from "@/ui-lib/icons/IconMongoDb";
import IconOracleCloud from "@/ui-lib/icons/IconOracleCloud";
import IconSnowflake from "@/ui-lib/icons/IconSnowflake";
import { faFolderArrowUp } from "@fortawesome/pro-regular-svg-icons";
import { CloudProviderType } from "@ternary/api-lib/constants/enums";
import Icon from "@ternary/api-lib/ui-lib/components/Icon";
import React from "react";

interface Props {
  providerType: CloudProviderType;
  size?: number;
}

export function DataIntegrationIcon({
  providerType,
  size = 24,
}: Props): React.JSX.Element {
  switch (providerType) {
    case CloudProviderType.ALIBABA:
      return <IconAlibabaCloud size={size} />;
    case CloudProviderType.AWS:
      return <IconAwsCloud size={size} />;
    case CloudProviderType.AZURE:
      return <IconAzure size={size} />;
    case CloudProviderType.GENERIC_FOCUS:
      return <Icon icon={faFolderArrowUp} style={{ fontSize: size }} />;
    case CloudProviderType.GCP:
      return <IconGCP size={size} />;
    case CloudProviderType.MONGO_DB:
      return <IconMongoDb size={size} />;
    case CloudProviderType.OCI:
      return <IconOracleCloud size={size} />;
    case CloudProviderType.SNOWFLAKE:
      return <IconSnowflake size={size} />;
    default:
      return providerType satisfies never;
  }
}
